export default {
  default: "Coś poszło nie tak spróbuj ponownie.",
  "Invalid video": "Wideo słabej jakości, spróbuj ponownie."
};
